export default __webpack_public_path__ + "static/media/IMG_4885.2fb06af5.JPG";